import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { DefaultResponse } from "../models/system";

export default function useCustomerUsage() {
    const { get, post, put, patch, del } = useApiHelper();
    const queryClient = useQueryClient();

    const increaseUsage = useMutation({
        mutationFn: (body: any) => patch<DefaultResponse>(`/customer/usage`, body),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["customer", "usage"] });
            queryClient.invalidateQueries({ queryKey: ["customer", "brand"] });
        }
    });

    return {
        increaseUsage
    }
}